import type { FieldControl } from '../fieldset/ui-fieldset.type';
import type { ElementConfig } from '../ui-element.type';
import type { UISliderControlConfig } from './ui-slider.type';

/**
 * Create an ElementConfig based on FieldControl.
 * @param {FieldControl} control
 * @returns {ElementConfig}
 * @private
 */
export function fromControlConfig(control: FieldControl): ElementConfig {
    const config = (control.config || {}) as UISliderControlConfig;
    return {
        tagName: 'ui-slider',
        attributes: {
            class: config.class ?? null,
            units: config.units,
        },
        children: [
            {
                tagName: 'input',
                attributes: control.attributes,
            },
        ],
    };
}
